export default __webpack_public_path__ + "static/media/coloured-card-with-btn.c4457c00.png";